import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, MapPinIcon, BookOpenIcon, SparklesIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const chips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: MapPinIcon,
  label: 'Para Argentina'
}, {
  icon: SparklesIcon,
  label: 'Lashistas'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-83" data-mp="ncgl8inv6vvb">
      <div className="mx-auto max-w-4xl px-5 text-center sm:pt-16 pt-[35px] pb-[5px]" data-id="element-84" data-mp="nbydaoruat7k">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="font-extrabold uppercase tracking-[0.25em] text-rose-soft mt-[-25px] mb-[-25px] text-[12px]" data-id="element-85" data-mp="3d33d6tuq0lin">
          🏆 Sigma Smart™
        </motion.p>

        

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="tracking-tight sm:text-7xl pb-[33px] font-[800] text-center font-[Cinzel,_serif] text-[#F7EEF1FD] text-[28px] pt-[34px] bg-[#140F10]" data-id="element-86" data-mp="3o6apvvoqw6zy">
          Tu agenda mensual
          <br data-id="element-87" data-mp="30ggfdkrweuiv" />
          <span className="text-[#E69FB3]" data-id="element-88" data-mp="30fy7fqvvirv4">resuelta desde hoy</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mx-auto max-w-xl w-[334px] h-[297px] pb-[19px] mt-[-10px] mb-[-10px]" data-id="element-89" data-mp="35a2gqgsm3bzd">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-rose/20 blur-3xl" data-id="element-90" data-mp="2hjf63nrba894" />
          <img src="https://cdn.magicpatterns.com/uploads/5YUpZ293eRHr1xo4n17CVz/ChatGPT_Image_20_jul_2026,_12_19_39.png" alt="MEGAPACK AGENDA LLENA — sistema completo para lashistas" className="animate-floaty mx-auto rounded-2xl w-[260px] h-[260px]" data-id="element-91" data-mp="2lla8ywow4tp0" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mx-auto max-w-2xl font-bold text-rose-soft sm:text-xl pt-[0px] pb-[0px] text-[16px] mt-[-2px] mb-[-2px]" data-id="element-92" data-mp="ic87ve5ce4xb">
          MEGAPACK AGENDA LLENA
El Sistema N°1 para Lashistas en Argentina
        </motion.h2>

        

        

        

        <div className="mt-9" data-id="element-93" data-mp="162ccnou9oapw">
          <CTAButton data-id="element-94" data-mp="112pvx5f8cccc">Quiero mi MegaPack ahora</CTAButton>
        <p className="mx-auto mt-4 max-w-2xl text-white/70 sm:text-lg text-[14px] pt-[15px]" data-id="element-95" data-mp="111eqz2a1syjn">
          Scripts de WhatsApp + Protocolo Anti-Cancelaciones + Ingeniería de Precios + Finanzas listos para aplicar.
Sin rogar clientas. Sin improvisar.
Sin perder más turnos.
        </p><div className="mt-7 flex flex-wrap justify-center gap-2.5 pt-[7px]" data-id="element-96" data-mp="3hr3sxz3awh7e">
          {chips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-white/80" data-id="element-97" data-mp="1x784pmxv7ptl">
              <Icon className="h-3.5 w-3.5 text-rose-soft" data-id="element-98" data-mp="2697ouo46fa0r" />
              {label}
            </span>)}
        </div><p className="mt-4 text-sm font-semibold text-white/50 pt-[7px]" data-id="element-99" data-mp="2b2aggqpe89eb">
          12 Tomos · 5 Bonos · 100+ páginas
Todo resuelto.
        </p></div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50 mt-[10px] mb-[10px]" data-id="element-100" data-mp="2kynbbrwoctan">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-101" data-mp="2u03k5v7ucncr">
              <Icon className="h-4 w-4 text-gold" data-id="element-102" data-mp="umhd09b8efna" />
              {label}
            </span>)}
        </div>
      <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="inline-flex items-center gap-2 rounded-full border border-rose/30 bg-rose/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-rose-soft pt-[4px] pb-[4px] mt-[18px] mb-[18px]" data-id="element-103" data-mp="zlkl62mid1zh">
          🔥 Oferta de lanzamiento — el precio cierra pronto
        </motion.div></div>
    </header>;
}